var EXTERNAL_INFO_TYPE = {
    HOVER: 'HOVER',
    EXTERNAL: 'EXTERNAL',
    SLIDESHOW: 'SLIDESHOW',
    COLLECTIONS_HOVER: 'COLLECTIONS_HOVER',
};
export default EXTERNAL_INFO_TYPE;
//# sourceMappingURL=externalInfoType.js.map